import * as postActions from '../actions/post.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { ObjectService } from '../services/object.service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  loadDefaultPermissions,
  loadDefaultPermissionsFailure,
  loadDefaultPermissionsSuccess,
  loadObjectsPermissions,
  loadObjectsPermissionsFailure,
  loadObjectsPermissionsSuccess,
} from '../actions/permissions.actions';

import { Injectable } from '@angular/core';
import { ObjectDefinition } from '../models/core.models';

// Replace with the actual path to your service

@Injectable()
export class PermissionsEffects {
  $loadObjectsPermissions = createEffect(() =>
    this.actions$.pipe(
      ofType(loadObjectsPermissions),
      mergeMap((action) => {
        let objectDefinition: ObjectDefinition[] = action.objects.map(
          (object) => {
            return {
              object_class_id: object.object_class_id,
              object_id: object.id,
              object_type_id: object.object_type_id,
            };
          },
        );

        return this.permissionsService
          .fetchObjectsPermissions(objectDefinition)
          .pipe(
            map((response) =>
              loadObjectsPermissionsSuccess({ data: response }),
            ),
            catchError((error) => of(loadObjectsPermissionsFailure({ error }))),
          );
      }),
    ),
  );
  loadDefaultObjectsPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDefaultPermissions),
      mergeMap((action) => {
        return this.permissionsService
          .fetchDefaultObjectClassPermissions(action.objectClassId)
          .pipe(
            map((response) =>
              loadDefaultPermissionsSuccess({ data: response }),
            ),
            catchError((error) => of(loadDefaultPermissionsFailure({ error }))),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private permissionsService: ObjectService,
  ) {}
}
